/**
 * Live/Prematch grid's columns and menu-layers settings.
 */
export const BREAKPOINTS_PROPS = {
  'extraSmall-1279': {
    maxScreenWidth: 1279,
    sidebarResizeStep: 100,
  },
  'small': {
    maxScreenWidth: 1344,
    sidebarResizeStep: 100,
  },
  'small-1359': {
    maxScreenWidth: 1359,
    sidebarResizeStep: 50,
  },
  'small-1538': {
    maxScreenWidth: 1538,
    sidebarResizeStep: 50,
  },
  'small-1607': {
    maxScreenWidth: 1607,
    sidebarResizeStep: 50,
  },
  'small-1647': {
    maxScreenWidth: 1647,
    sidebarResizeStep: 150,
  },
  'medium': {
    maxScreenWidth: 1679,
    sidebarResizeStep: 45,
  },
  'medium-1730': {
    maxScreenWidth: 1730,
    sidebarResizeStep: 120,
  },
  'medium-1780': {
    maxScreenWidth: 1780,
    sidebarResizeStep: 140,
  },
  'large': {
    maxScreenWidth: 1815,
    sidebarResizeStep: 80,
  },
  'large-1870': {
    maxScreenWidth: 1870,
    sidebarResizeStep: 100,
  },
  'extraLarge': {
    maxScreenWidth: 1921,
    sidebarResizeStep: 150,
  },
  'extraLarge-2048': {
    maxScreenWidth: 2048,
    sidebarResizeStep: 150,
  },
  'extraLargePlus-2220': {
    maxScreenWidth: 2220,
    sidebarResizeStep: 150,
  },
  'infinity': {
    maxScreenWidth: 4096,
    sidebarResizeStep: 150,
  },
};

/* Create custom breakpoints for the `redux-responsive` lib */
export const REDUX_RESPONSIVE_BREAKPOINTS =
  Object.keys(BREAKPOINTS_PROPS).reduce((breakpoints, keyPoint) => {
    breakpoints[keyPoint] = BREAKPOINTS_PROPS[keyPoint].maxScreenWidth;
    return breakpoints;
  }, {});
